export default class StickySidebar {
  constructor(selector, notStickySelector) {
    this.selector = selector;
    this.notStickySelector = notStickySelector;
    this.instances = [];

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.resizeTimer = null;

    this.init();
  }

  getTopOffset() {
    const header = document.querySelector(".js-header");
    return header ? header.offsetHeight + 20 : 20;
  }

  init() {
    const elements = Array.from(document.querySelectorAll(this.selector));
    if (!elements.length) return;

    this.instances = elements.map((el) => this.createInstance(el));

    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize);
  }

  createInstance(el) {
    const container = el.parentElement;

    const notStickyElem = container.querySelector(this.notStickySelector);

    const inst = {
      el,
      container,
      withRightOffset: container.classList.contains("offset-right"),
      isFixed: false,
      isBottom: false,
      canStick: true,
      topOffset: 0,
      width: 0,
      height: 0,
      stickPoint: 0,
      bottomPoint: () => 0,
    };

    inst.recalc = () => {
      inst.topOffset = this.getTopOffset();
      inst.width = inst.withRightOffset
        ? inst.container.clientWidth + 30
        : inst.container.clientWidth;

      inst.height = window.innerHeight - inst.topOffset - 10;

      const rect = inst.container.getBoundingClientRect();
      const containerTop = rect.top + window.pageYOffset;
      const containerHeight = inst.container.offsetHeight;

      const notStickyHeight = notStickyElem
        ? notStickyElem.offsetHeight + 30
        : 0;

      inst.stickPoint = containerTop - inst.topOffset + notStickyHeight;

      inst.bottomPoint = () =>
        containerTop + containerHeight - inst.el.offsetHeight - inst.topOffset;

      inst.canStick = containerHeight > inst.height;

      if (inst.canStick) {
        inst.el.style.height = inst.height + "px";

        if (inst.isFixed) {
          inst.el.style.width = inst.width + "px";
        }
      } else {
        inst.el.style.height = "";
        inst.el.style.width = "";
        inst.applyStatic();
      }
    };

    inst.applyFixed = () => {
      inst.el.classList.add("element-fixed");
      inst.el.classList.remove("element-static", "element-absolute-bottom");
      inst.el.style.top = inst.topOffset + "px";
      inst.el.style.width = inst.width + "px";
      inst.isFixed = true;
      inst.isBottom = false;
    };

    inst.applyStatic = () => {
      inst.el.classList.add("element-static");
      inst.el.classList.remove("element-fixed", "element-absolute-bottom");
      inst.el.style.top = "";
      inst.el.style.width = "";
      inst.isFixed = false;
      inst.isBottom = false;
    };

    inst.applyBottom = () => {
      inst.el.classList.add("element-absolute-bottom");
      inst.el.classList.remove("element-fixed", "element-static");
      inst.el.style.top = "";
      inst.isBottom = true;
      inst.isFixed = false;
    };

    inst.update = () => {
      if (!inst.canStick) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      // top point - fixing
      if (scrollTop >= inst.stickPoint) {
        if (!inst.isFixed) {
          inst.applyFixed();
        }
      } else if (inst.isFixed) {
        inst.applyStatic();
      }

      // bottom point - absolute
      if (scrollTop >= inst.bottomPoint() && inst.isFixed) {
        inst.applyBottom();
      } else if (inst.isBottom && scrollTop < inst.bottomPoint()) {
        inst.applyFixed();
      }
    };

    // starting setup
    inst.recalc();
    inst.update();

    return inst;
  }

  onScroll() {
    this.instances.forEach((inst) => inst.update());
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.instances.forEach((inst) => {
        inst.recalc();
        inst.update();
      });
    }, 100);
  }

  destroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);

    clearTimeout(this.resizeTimer);

    this.instances.forEach((inst) => {
      inst.el.classList.remove(
        "element-fixed",
        "element-static",
        "element-absolute-bottom",
      );
      inst.el.style.top = "";
      inst.el.style.width = "";
      inst.el.style.height = "";
    });

    this.instances = [];
  }
}
